import React, { FC, useEffect, useState } from 'react';
import EmployeeSelect from './EmployeeSelect';
import { LegacyEmployee } from 'src/interfaces/api/Employee';
import { Skeleton } from '@material-ui/lab';
import useAuth from 'src/hooks/api/useAuth';

interface Props {
  className?: string;
  userId: number;
  onChange: (employeeId: number) => void;
}

const EmployeeSelectContainer: FC<Props> = ({ ...props }) => {
  const { loading, employees, error } = useLegacyEmployee();

  if (error) {
    return null;
  }

  if (loading || employees.length <= 0) {
    return <Skeleton width={200} />;
  }

  return <EmployeeSelect employees={employees} {...props} />;
};

const useLegacyEmployee = () => {
  const [employees, setEmployees] = useState<LegacyEmployee[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>();
  const { fetch } = useAuth();

  const fetchEmployees = (): Promise<LegacyEmployee[]> => {
    const endpoint = '/api/employee/{employees{id, firstname, lastname, user{id}}}';

    return fetch(endpoint, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'GET',
    })
      .then((res) => res.json())
      .then((res) => {
        const dataToMap = res?.data?.employees || [];

        return dataToMap.map(
          (employee): LegacyEmployee => ({
            id: employee['id'],
            firstname: employee['firstname'],
            lastname: employee['lastname'],
            user: { id: employee['user']['id'] },
          })
        );
      });
  };

  useEffect(() => {
    setError(undefined);
    setLoading(true);

    fetchEmployees()
      .then((employees) => {
        setEmployees(employees);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setError('Echec lors de la récupération des employés');
      });
  }, []);

  return { employees, loading, error };
};

export default EmployeeSelectContainer;
